module.exports = __webpack_public_path__ + "assets/img/logo.52252a5.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/logo.svg
// module id = 187
// module chunks = 30